import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('TermDisplayController', TermDisplayController);

    function TermDisplayController($filter, $translate, DateService) {
        var vm = this;

        init();

        function init() {
            vm.displayTerm = setDisplayTerm();
        }

        function setDisplayTerm() {
            switch (vm.priority) {
                case 'critical':
                    return "Natychmiastowe";
                default:
                    if (vm.realizationDateFrom) {
                        return displayDateTerm();
                    }
                    return "";
            }
        }

        function displayDateTerm() {
            var startDate = $filter('date')(
                vm.realizationDateFrom,
                'shortDate'
            );
            var startTime = $filter('date')(
                vm.realizationDateFrom,
                'shortTime'
            );
            var endDate = $filter('date')(vm.realizationDateTo, 'shortDate');
            var endTime = $filter('date')(vm.realizationDateTo, 'shortTime');

            if (DateService.checkIsValidDate(vm.realizationDateFrom)) {
                if (vm.realizationDateFrom === vm.realizationDateTo) {
                    return startDate;
                }

                return startDate + ' - ' + endDate;
            }

            if (startDate !== endDate) {
                return (
                    startDate +
                    ' ' +
                    startTime +
                    ' - ' +
                    endDate +
                    ' ' +
                    endTime
                );
            }

            return startDate + ' ' + startTime + ' - ' + endTime;
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/data-presentation/term-display/term-display.controller.ts